import URL from 'url-parse';

type ShareOptions = {
    url: string,
    text?: string,
    hashtags?: string[],
    via?: string,
}

export class Twitter {
    static shareURL(shareOptions: ShareOptions) {
        const shareURL = new URL('https://twitter.com/intent/tweet');

        const query = {
            ...shareOptions,
        };

        if (shareOptions.hashtags) {
            query.hashtags = shareOptions.hashtags.join(',');
        }

        shareURL.set('query', query);

        return shareURL.href;
    }

}

